import { render } from "./ClubCard.vue?vue&type=template&id=25b7ee3e&scoped=true"
import script from "./ClubCard.vue?vue&type=script&lang=js"
export * from "./ClubCard.vue?vue&type=script&lang=js"

import "./ClubCard.vue?vue&type=style&index=0&id=25b7ee3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b7ee3e"]])

export default __exports__